import { createBrowserHistory } from 'history';
import { debounce } from 'throttle-debounce';

import { IApplicationState } from '../../../shared/common/types/redux';

const history = createBrowserHistory();

function queryStringUpdaterFn(state: IApplicationState) {
  const isSeoUrl = state.seoUrl !== null;

  let newPathName: string;
  if (
    history.location.pathname.startsWith('/dailyrent') ||
    history.location.pathname.startsWith('/map') ||
    history.location.pathname.startsWith('/cat.php')
  ) {
    newPathName = history.location.pathname;
  } else {
    newPathName = '/cat.php';
  }

  /**
   * Если сервис работает в контексте ЧПУ, то не нужно обновлять queryString
   */
  if (isSeoUrl) {
    return;
  }

  if (window.location.search.slice(1) !== state.queryString) {
    const newLocation = {
      pathname: newPathName,
      search: `?${state.queryString}`,
      hash: history.location.hash,
      state: history.location.state,
    };

    history.replace(newLocation);
  }
}

export const queryStringUpdater = debounce(300, queryStringUpdaterFn);
